/* eslint-disable react/no-unknown-property */
import React from 'react';

import Section from 'react-scale/components/elements/section';
import FeatureTitle from 'react-scale/components/pages/open-datasets/FeatureTitle';
import { Grid, GridItem } from 'react-scale/components/website/big/main/Grid';
import FeaturesList from 'react-scale/components/website/big/open-datasets/shared/FeaturesList';
import Sensors from 'react-scale/components/website/big/open-datasets/waterloo/Sensors';

import { mq } from 'react-scale/components/website/big/Themes';

class SensorCalibration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: ''
    };
  }

  updateHighlight = type => {
    this.setState({ highlight: type });
  };

  render() {
    const { highlight } = this.state;

    const {
      iconColors,
      overtitle,
      title,
      text,
      background,
      sensorDetailsList,
      dataset,
      caseColor
    } = this.props;

    return (
      <Section id="sensor-calibration">
        <div className="sensor-calibration-block">
          <FeatureTitle
            iconSVG={<Icon colors={iconColors} />}
            overtitle={overtitle}
            title={title}
            subtitle={text}
            caseColor={caseColor}
          />
          <div className="text-white car-sensor-illustration">
            <Grid margin={{ xl: 0, lg: 0, md: 0, xs: 0 }} vAlign="center">
              <GridItem lg="1 / 5" xl="1 / 5" md="1 / 5">
                <FeaturesList
                  items={sensorDetailsList}
                  iconSrc={dataset}
                  onHover={this.updateHighlight}
                />
              </GridItem>
              <GridItem xl="5 / 13" lg="5 / 13" md="5 / 9">
                <div className="illustration-wrapper">
                  {dataset === 'waterloo' && (
                    <div className="car-sensors-graphic">
                      <Sensors className={highlight} />
                    </div>
                  )}
                  {dataset !== 'waterloo' && (
                    <img
                      className="car-sensors-graphic"
                      src={`/static/img/website/open-datasets/${dataset}/car-sensors.svg`}
                      alt="Car Sensors"
                    />
                  )}
                </div>
              </GridItem>
            </Grid>
          </div>
        </div>
        <style jsx>{`
          .sensor-calibration-block {
            overflow: hidden;
          }

          .car-sensor-illustration {
            position: relative;
          }
          .car-sensor-illustration:before {
            position: absolute;
            top: 0;
            left: 50%;
            right: 0;
            bottom: 0;
            background: ${background};
            z-index: 0;
          }
          @media (min-width: ${mq.lg}) {
            .car-sensor-illustration:before {
              content: '';
            }
          }
          .car-sensor-illustration .illustration-wrapper {
            background: ${background};
          }
          .car-sensor-illustration .car-sensors-graphic {
            max-width: 350px;
            padding: calc(2rem * 2) 0;
            margin: 0 auto;
            position: relative;
            z-index: 10;
          }
          @media (min-width: ${mq.xl}) {
            .car-sensor-illustration .car-sensors-graphic {
              max-width: 100%;
              padding: calc(2rem * 3) 0;
            }
          }
        `}</style>
      </Section>
    );
  }
}

SensorCalibration.defaultProps = {
  overtitle: { text: 'Sensor Calibration' },
  title: 'Data alignment between sensors and cameras',
  text: [
    'To achieve a high quality multi-sensor dataset, it is essential to calibrate the extrinsics and intrinsics of every sensor.',
    'We express extrinsic coordinates relative to the ego frame, i.e. the midpoint of the rear vehicle axle.',
    'The most relevant steps are described below:'
  ],
  sensorDetailsList: [
    {
      text: 'LiDAR extrinsics'
    },
    {
      text: 'Camera extrinsics'
    },
    {
      text: 'Camera intrinsic calibration'
    },
    {
      text: 'IMU extrinsics'
    }
  ]
};

const Icon = ({ colors }) => (
  <svg viewBox="0 0 144 144">
    <path
      d="M72 144C111.765 144 144 111.765 144 72C144 32.2355 111.765 0 72 0C32.2355 0 0 32.2355 0 72C0 111.765 32.2355 144 72 144Z"
      fill="black"
    />
    {/* <path
      d="M91.2 30C78.62 30 68.4 40.22 68.4 52.8V63.6H75.6V52.8C75.6 44.2 82.6 37.2 91.2 37.2C99.8 37.2 106.8 44.2 106.8 52.8C106.8 61.4 99.8 68.4 91.2 68.4H52.8C40.22 68.4 30 78.62 30 91.2C30 103.78 40.22 114 52.8 114C65.38 114 75.6 103.78 75.6 91.2V80.4H68.4V91.2C68.4 99.8 61.4 106.8 52.8 106.8C44.2 106.8 37.2 99.8 37.2 91.2C37.2 82.6 44.2 75.6 52.8 75.6H91.2C103.78 75.6 114 65.38 114 52.8C114 40.22 103.78 30 91.2 30Z"
      fill="black"
    /> */}
    <path
      d="M100.8 52.8L104.24 55.76L108 52.8C108 43.52 100.48 36 91.2004 36C81.9204 36 74.4004 43.52 74.4004 52.8V62.4L78.1404 65.24L81.6004 62.4V52.8C81.6004 47.5 85.9004 43.2 91.2004 43.2C96.5004 43.2 100.8 47.5 100.8 52.8Z"
      fill={colors[0]}
    />
    <path
      d="M91.2004 31.2C103.12 31.2 112.8 40.88 112.8 52.8L116.44 55.76L120 52.8C120 36.9 107.1 24 91.2004 24C75.3004 24 62.4004 36.9 62.4004 52.8V62.4L66.0204 65.24L69.6004 62.4V52.8C69.6004 40.88 79.2804 31.2 91.2004 31.2Z"
      fill={colors[0]}
    />
    <path
      d="M43.2 91.1998L39.76 88.2398L36 91.1998C36 100.48 43.52 108 52.8 108C62.08 108 69.6 100.48 69.6 91.1998V81.5998L65.86 78.7598L62.4 81.5998V91.1998C62.4 96.4998 58.1 100.8 52.8 100.8C47.5 100.8 43.2 96.4998 43.2 91.1998Z"
      fill={colors[1]}
    />
    <path
      d="M52.8 112.8C40.88 112.8 31.2 103.12 31.2 91.1998L27.56 88.2398L24 91.1998C24 107.1 36.9 120 52.8 120C68.7 120 81.6 107.1 81.6 91.1998V81.5998L77.98 78.7598L74.4 81.5998V91.1998C74.4 103.12 64.72 112.8 52.8 112.8Z"
      fill={colors[1]}
    />
    <path
      d="M52.8 69.5998H91.2C100.48 69.5998 108 62.0798 108 52.7998H100.8C100.8 58.0998 96.5 62.3998 91.2 62.3998H52.8C36.9 62.3998 24 75.2998 24 91.1998H31.2C31.2 79.2798 40.88 69.5998 52.8 69.5998Z"
      fill={colors[2]}
    />
    <path
      d="M112.8 52.7998C112.8 64.7198 103.12 74.3998 91.2 74.3998H52.8C43.52 74.3998 36 81.9198 36 91.1998H43.2C43.2 85.8998 47.5 81.5998 52.8 81.5998H91.2C107.1 81.5998 120 68.6998 120 52.7998H112.8Z"
      fill={colors[2]}
    />
  </svg>
);

export default SensorCalibration;
